import { DragAndDrop } from "../core/components/dnd";
import { ReportDefinition } from "./reportMetaData";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { Config } from "../core/config/config";
import { Dialog, DialogProps } from "../core/components/dialog";
import { ComponentHelper } from "../core/util/componentHelper";
import { FieldInstance } from "../core/components/field";
import { CheckBox } from "../core/components/checkBox";
import { NotificationHelper } from "../core/util/notificationHelper";
import { FileUpload, File } from "../core/components/fileUpload";
import { DropDownList } from "../core/components/dropDownList";
import { ReportMetaDataHelper, Language } from "./reportMetaDataHelper";
import { GridCustomToolBarButton } from "../core/components/toolBar";
import React from "react";
export default class ReportFiles extends React.Component<ReportFilesProps, ReportFilesState> {
    private gridOptions: kendo.ui.GridOptions;
    private dialog: ReportFilesDialog;
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (!Helper.isNullOrEmpty(this.state.file)) {
                        this.setState({ dialogOpen: false }, () => {
                            this.dialog.edit(this.state.gridData, this.state.file);
                        })
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false })
        },
        width: 500
    };
    private disabled: boolean;
    private colors = {
        background: "#FE4164",
        font: "#FFFFFF"
    }
    //private dir: string;
    //private directory: string;
    constructor(props: ReportFilesProps) {
        super(props);
        this.state = {
            gridData: [],
            dialogOpen: false,
            file: "",
            buttonsEnabled: false
        }
        //this.dir = kendo.guid();
        this.disabled = !props.entity.RecordRight.CanWrite;
        this.initApp();
    }

    private onChange = () => {
        let obj: {} = {};
        for (let i = 0; i < this.state.gridData.length; i++) {
            obj[this.state.gridData[i].key] = this.state.gridData[i].file;
        }
        this.props.onChange({ model: "entity.ReportFiles"}, obj)
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "language",
                    title: this.props.context.translations["Field.Adresse.language"]
                },
                {
                    field: "key",
                    title: this.props.context.translations["Standard.LanguageCode"]
                },
                {
                    field: "fileName",
                    title: this.props.context.translations["WebSMS.ReportMetadata.File"]
                }
            ]
        };

        ReportMetaDataHelper.getLanguages().then((languages: Language[]) => {
            const keys = Object.keys(this.props.entity.ReportFiles);
            let data: GridData[] = languages.map((item) => {
                let file: string = null;
                let exist = keys.findIndex(f => f.toLowerCase() === item.Code.toLowerCase()) > -1;
                if (exist) {
                    file = this.props.entity.ReportFiles[item.Code.toLowerCase()];
                }
                return {
                    key: item.Code,
                    file: file,
                    language: item.Displaynameen + " (" + item.Displaynamenative + ")",
                    colorize: false,
                    fileName: ReportMetaDataHelper.getFileName(file)
                };
            });
            if (this.disabled) {
                keys.filter(f1 => data.findIndex(f2 => f2.key === f1) === -1).map((key) => {
                    let file: string = this.props.entity.ReportFiles[key];
                    data.push({
                        colorize: true,
                        file: file,
                        key: key,
                        language: key,
                        fileName: ReportMetaDataHelper.getFileName(file)
                    });
                });
            }
            this.setState({ gridData: data })
        });
    }

    private isQuickReport = (file): boolean => {
        let name: string = file["name"];
        let arr = name.split('.');
        let fileType = arr[arr.length - 1];
        return fileType.toLowerCase() === "qra";
    }

    private uploadFile = (file) => {
        if (this.isQuickReport(file)) {
            const formData = new FormData();
            formData.append('file', file);
            HTTPService.post<JsonResultClass<string>>("ReportMetaData/UploadFile", formData).then(result => {
                switch (result.Code) {
                    case 0:
                        this.dialog.edit(this.state.gridData, result.Data);
                        break;
                    case 1:
                        NotificationHelper.showErrorMessage(result.Message);
                        break;
                }
            });
        } else {
            NotificationHelper.showErrorMessage(this.props.context.translations["WebSMS.ReportMetadata.PleaseSelectQRFile"])
        }
    }

    private handleDrop = (files) => {
        if (files.length > 0) {
            this.uploadFile(files[0]);
        }        
    }

    private createDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    {this.createDropDown()}
                </Dialog>
            </>
        );
    }

    private createDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.field.dataSourceUrl = "ReportMetaData/GetAllQrReports";// + (Helper.isNullOrEmpty(this.directory) ? "" : ("?path=" + this.directory));
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.value = this.state.file;
        props.onChange = (field, value) => {
            this.setState({ file: value })
        }
        return (
            <>
                <FieldInstance label={this.props.context.translations["WebSMS.ReportMetadata.File"]}>
                    <DropDownList {...props}/>
                </FieldInstance>
            </>
            );
    }

    private createUpLoader = () => {
        const validateFile = (file: File) => {
            if (file.extension.toLowerCase() === ".qra") {
                return true;
            } else {
                NotificationHelper.showErrorMessage(this.props.context.translations["WebSMS.ReportMetadata.PleaseSelectQRFile"])
                return false;
            }
            
        }
        const upload = (file: File) => {
            this.uploadFile(file.rawFile);
        }
        return (
            <>
                <FileUpload validate={validateFile} upload={upload} />
            </>
        );
    }

    private createGrid = () => {
        let customButtons: GridCustomToolBarButton[] = [];

        if (!this.props.entity.IsNew) {
            customButtons = [
                { autoEnabledOnRecordSelected: true, caption: this.props.context.translations["Server.Download"], enabled: this.state.buttonsEnabled, iconClass: "k-i-download", id: "download" },
                { autoEnabledOnRecordSelected: false, caption: this.props.context.translations["WebSMS.ReportMetadata.DownloadAll"], enabled: this.state.gridData.filter(f => !Helper.isNullOrEmpty(f.file)).length > 0, iconClass: "k-i-zip", id: "downloadAll" },
            ];
        }
        if (!this.disabled) {
            customButtons.unshift({ autoEnabledOnRecordSelected: true, caption: Config.translations.delete, enabled: this.state.buttonsEnabled, iconClass: "k-i-close", id: "revert" });
        } 
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="ReportFiles"
                    customButtons={customButtons}
                    onClickCustomButton={this.handleClickCustomButton}
                    onDataBound={this.handleDataBound}
                    onSelectionChanged={this.handleOnSelectionChange}
                />
            </div>
        );
    }

    private handleOnSelectionChange = (dataItem: GridData) => {
        this.setState({ buttonsEnabled: Helper.hasValue(dataItem) && !Helper.isNullOrEmpty(dataItem.file) });
    }

    private handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].colorize) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", this.colors.background);
                cell.css("color", this.colors.font);
            }
        }
    }

    private downloadFile = (languageCode: string) => {
        const url = `${Config.baseUrl}ReportMetaData/DownloadFile?reportId=${this.props.entity.Id}&languageCode=${languageCode}`;
        Helper.openInNewBrowserTab(url);
    }

    private downloadAllFiles = () => {
        const url = `${Config.baseUrl}ReportMetaData/DownloadAllFiles?reportId=${this.props.entity.Id}`;
        Helper.openInNewBrowserTab(url);
    }


    private handleClickCustomButton = (id: string, dataItem: GridData) => {
        switch (id) {
            case "revert":
                let gridData = this.state.gridData;
                let index = gridData.findIndex(f => f.key === dataItem.key);
                gridData[index].file = null;
                gridData[index].fileName = null;
                this.setState({ gridData: gridData }, this.onChange);
                break;
            case "chooseFile":
                this.setState({ dialogOpen: true, file: "" })
                break;
            case "download":
                this.downloadFile(dataItem.key);
                break;
            case "downloadAll":
                this.downloadAllFiles();
                break;
        }
    }

    componentDidUpdate(prevProps) {
        const disabled = !this.props.entity.RecordRight.CanWrite;
        if (this.disabled !== disabled) {
            this.disabled = disabled;
            this.setState({})
        }
    }

    render() {
        const dialog = (this.state.dialogOpen ? this.createDialog() : null);
        const upLoader = !this.disabled ? this.createUpLoader() : null;
        const body = (
            <>
                {upLoader}
                {this.createGrid()}
            </>
        );
        return (
            <div style={{ height: "100%", overflow: "hidden" }}>
                {!this.disabled ? <DragAndDrop handleDrop={this.handleDrop} children={body} /> : <div children={body} />}
                <ReportFilesDialog onOk={(gridData: GridData[]) => { this.setState({ gridData: gridData }, this.onChange) }} ref={(ref) => { this.dialog = ref }} />
                {dialog}
            </div>
        );
    }

}

interface ReportFilesProps {
    onChange: (field, value) => void;
    entity: ReportDefinition;
    context: {
        translations: {}
    }
}

interface ReportFilesState {
    gridData: GridData[];
    dialogOpen: boolean;
    file?: string;
    buttonsEnabled: boolean;
}

class ReportFilesDialog extends React.Component<ReportFilesDialogProps, ReportFilesDialogState> {
    private factory = ComponentHelper.createFactory();
    private fileName: string;
    private baseGridData: GridData[];
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    let gridData: GridData[] = this.baseGridData;
                    for (let i = 0; i < gridData.length; i++) {
                        let index = this.state.data.findIndex(f => f.key === gridData[i].key);
                        if (this.state.data[index].selected) {
                            gridData[i].file = this.fileName;
                            gridData[i].fileName = this.getFileName(this.fileName)
                        } 
                    }
                    this.props.onOk(gridData);
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false })
        },
        width: 500
    };


    constructor(props) {
        super(props)
        this.state = {
            data: [],
            dialogOpen: false
        }
    }

    private getFileName = (path: string) => {
        if (Helper.isNullOrEmpty(path))
            return "";
        let arr = path.split("\\");
        return arr[arr.length - 1];
    }

    edit = (gridData: GridData[], fileName: string) => {
        let lst: SelectedLangugages[] = gridData.map((item) => {
            return {
                key: item.key,
                language: item.language,
                selected: Helper.isNullOrEmpty(item.file)
            };
        });
        this.fileName = fileName;
        this.baseGridData = gridData;
        this.setState({ data: lst, dialogOpen: true })
    }

    private createDialog = () => {
        let body: JSX.Element[] = this.state.data.map((item) => {
            return this.createCheckBox(item);
        })
        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    {body}
                </Dialog>
            </>
        );
    }


    private createCheckBox = (data: SelectedLangugages) => {
        let props = this.factory.getDefaultCheckBoxProps();
        props.value = data.selected;
        props.onChange = (field, value: boolean) => {
            let lst = this.state.data;
            let index = lst.findIndex(f => f.key === data.key);
            lst[index].selected = value;
            this.setState({ data: lst });
        }
        return (
            <React.Fragment key={data.key}>
                <FieldInstance label={data.language}>
                    <CheckBox {...props}/>
                </FieldInstance>
            </React.Fragment>
            )
    }

    render() {
        const dialog = ( this.state.dialogOpen  ? this.createDialog() : null);
        return (<>{dialog}</>);
    }
}

interface ReportFilesDialogProps {
    onOk: (gridData: GridData[]) => void;
    onCancel?: () => void
}

interface ReportFilesDialogState {
    data: SelectedLangugages[];
    dialogOpen: boolean;
}

interface SelectedLangugages {
    key: string; //langugageCode
    selected: boolean;
    language: string;
}

interface GridData {
    colorize: boolean;
    key: string; //langugageCode
    file: string;
    fileName: string;
    language: string;
}